import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PayrollCard from '../../components/PayrollCard';
import { getPayrollByMonth } from '../../services/payrollService';

export default function PayrollMonthPage() {
  const { month } = useParams();
  const navigate = useNavigate();
  const [payroll, setPayroll] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getPayrollByMonth(month)
      .then(data => setPayroll(data))
      .finally(() => setLoading(false));
  }, [month]);

  return (
      <div className="max-w-2xl mx-auto py-8 px-2">
        {/* Breadcrumb */}
        <nav className="mb-6 text-sm text-gray-500 dark:text-gray-400">
          <span onClick={() => navigate('/')} className="hover:underline cursor-pointer">Dashboard</span> /
          <span onClick={() => navigate('/payroll')} className="hover:underline cursor-pointer ml-1">Payroll</span> /
          <span className="ml-1 font-semibold text-indigo-700 dark:text-indigo-300">{month}</span>
        </nav>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
          </div>
        ) : payroll ? (
          <PayrollCard payroll={payroll} />
        ) : (
          <div className="text-center text-gray-500 dark:text-gray-400">No payroll data found for this month.</div>
        )}
      </div>
  );
}
